<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Willamette Valley Wineries</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head1" id="Ack">A<span class="small">CKNOWLEDGMENTS</span></p>
<p class="para1">My friend Carl Giavanti warned me that once I started digging into the stories behind Oregon wines I would only be pulled deeper. He was right. I loved Oregon wines before I began this project, but my passion for them is now in full flame, fueled by the stories shared by winemakers and their families. They do not regard their lives as romantic or extraordinary; they simply answered a calling to grow the best grapes and make the best wines possible. A deep thank-you to all who welcomed me into your homes, vineyards, and wineries and shared your stories with me. I hope I have captured the essence of collaboration that permeates Willamette Valley wine history.</p>
<p class="para">Thanks to Rachael Cristine Woody, Rich Schmidt, and Linfield student Shelby Cook at Linfield College’s Oregon Wine History Archive for their assistance in preparing the photographs for this project. Unless otherwise noted, all photographs are from the archive, a treasury with delightful discoveries in every box. Thanks for being so welcoming and accommodating during my visits.</p>
<p class="para">I owe immeasurable gratitude to my editor, Arcadia senior title manager Liz Gurley, for her guidance and encouragement in every step of this process. It was a pleasure working with you.</p>
<p class="para">Thanks to Lauren Gaar of Dobbes Family Estate, who just happened to mention she knew Arcadia wanted this book to be written; to Carl Giavanti of Carl Giavanti Marketing; and to Dixie Huey of Trellis Growth Partners for introducing me to their winemaking clients. You know the nicest people.</p>
<p class="para">Finally, thanks to Mark, Dave, Whit, and Cole for all the love and spice you add to my life; to Mom, Marie, Ted, and the rest of the Smith and Randall clans for your encouragement, especially Tom for your computer savvy; to the Barr family for your willingness to accompany me on winery “research” trips; and to the Birthday Girls and my BADD sisters, with whom I have shared more than a glass of wine over the decades. Your friendship and support mean more than I can express.</p>
<p class="right1">Cheers and thank you,<br/>Barbara Smith Randall</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgment.vue?c4a48c8e